/* tslint:disable */
/* eslint-disable */
export enum WorkChatMessageTypeEnum {
  Text = 'text',
  System = 'system'
}
